export const VALID_EMAIL_REGEX = /^[A-Z0-9.'_%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const COMMA_SEPARATED_EMAIL_LIST =
  /^([A-Z0-9.'_%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(, ?)?)+$/i;

// taken from https://stackoverflow.com/questions/5066329/regex-for-valid-international-mobile-phone-number
/* eslint-disable-next-line */
export const VALID_PHONE_NUMBER_REGEX_STRICT = /^[\+]{0,1}[1-9]{1}[0-9]{3,14}$/; // strict - for phone numbers input using country code validator
// less strict - for manually entered or imported phone numbers.
// Two independent checks stacked together:
// 1. The lookahead `(?=(?:\D*\d){3,15}\D*$)` is the digit-count rule: it
//    asserts (without consuming anything) that the whole string contains
//    3-15 actual digits (E.164 max), regardless of what separators sit
//    between them.
// 2. The character class `[0-9+() -]{3,25}` is the what's-allowed rule:
//    only digits and common formatting characters, up to 25 characters
//    in total.
// Counting digits rather than total length means formatting never causes
// rejection: "+1 (970) 259-5606" is 17 characters but only 11 digits.
export const VALID_PHONE_NUMBER_REGEX =
  /^(?=(?:\D*\d){3,15}\D*$)[0-9+() -]{3,25}$/;
export const EMPTY_STRING_REGEX = /^\s*$/;

const MATCH_ALL_EMOJI =
  '(\\u00a9|\\u00ae|[\\u2000-\\u3300]|\\ud83c[\\ud000-\\udfff]|\\ud83d[\\ud000-\\udfff]|\\ud83e[\\ud000-\\udfff])';

export const VALID_TAG_CHARACTERS_REGEX = new RegExp(
  `^(${MATCH_ALL_EMOJI}|[\\w -])*$`
);

// Taken from update 2 here: https://stackoverflow.com/a/32045167/4815046
export const VALID_ISO_8601_DURATION_REGEX = new RegExp(
  '^P(?!$)(\\d+(?:\\.\\d+)?Y)?(\\d+(?:\\.\\d+)?M)?(\\d+(?:\\.\\d+)?W)?(\\d+(?:\\.\\d+)?D)?(T(?=\\d)(\\d+(?:\\.\\d+)?H)?(\\d+(?:\\.\\d+)?M)?(\\d+(?:\\.\\d+)?S)?)?$'
);

export const VALID_CLIENT_FACING_DISCOUNT_CODE = /^[a-zA-Z0-9]+$/;

export const VALID_FILENAME = /^[\w\-. ]+$/;

export const VALID_HEX_COLOUR = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;

export const VALID_FOLDER_NAME = /^[ a-zA-Z0-9_-]+$/;
